import { render } from "./TacticContextTypeCard.vue?vue&type=template&id=4a31e68b&scoped=true"
import script from "./TacticContextTypeCard.vue?vue&type=script&lang=js"
export * from "./TacticContextTypeCard.vue?vue&type=script&lang=js"

import "./TacticContextTypeCard.vue?vue&type=style&index=0&id=4a31e68b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a31e68b"]])

export default __exports__